import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { ApiRequestService } from '../../http/api-request.service';
import { AppMetadataHandler } from '../../../configs/app-metadata.handler'
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: Http,
    private apiRequest: ApiRequestService,
    private appMetadataHandler: AppMetadataHandler) { }

  private fetchedMenu = [
    {
      "module": "New Business",
      "menu": {
        "menuName": "Dashboard",
        "route": "app/dash",
        "submenu": [{}]
      }
    },
    {
      "module": "New Business",
      "menu": {
        "menuName": "Leads",
        "route": "app/leadList",
        "submenu": [{
          "menuName": "All Leads",
          "route": "app/leadList",
        },
        {
          "menuName": "Add Lead",
          "route": "app/addLead",
        }]
      }
    },
    {
      "module": "New Business",
      "menu": {
        "menuName": "Quotation",
        "route": "app/quoteList",
        "submenu": [{
          "menuName": "All Quotations",
          "route": "app/quoteList",
        },
        {
          "menuName": "Generate Quotation",
          "route": "app/addLead",
        }]
      }
    },
    {
      "module": "New Business",
      "menu": {
        "menuName": "Policy",
        "route": "app/policyList",
        "submenu": [{
          "menuName": "All Policies",
          "route": "app/policyList",
        },
        {
          "menuName": "Capture eApp",
          "route": "app/captureEapp",
        }]
      }
    }

  ]


  getMenu(): Observable<any> {
    let menuDataSubject: Subject<any> = new Subject<any>();
    let menuServiceData: any = {}
    // if (!this.appMetadataHandler.mockFlags.menu) {
      // this.apiRequest.get('menu')
      //   .subscribe(jsonResp => {
      //     console.log("RESULT OF MENU SERVICE");
      //     console.log(jsonResp);
      //     menuServiceData = {
      //       data: jsonResp
      //     }
      //     menuDataSubject.next(menuServiceData);
      //   })
    // }
    // else {
    //   menuServiceData = {
    //     data: this.appMetadataHandler.mockData.menu
    //   }
    //   return of(menuServiceData).pipe(delay(200))
    // }
    this.apiRequest.getCallWithAPIMapper('menuV2')
      .subscribe(jsonResp => {
        console.log("RESULT OF MENU SERVICE");
        console.log(jsonResp);
        menuServiceData = {
          data: jsonResp
        }
        menuDataSubject.next(menuServiceData);
      })
    return menuDataSubject
  }

}
